<script>
    export default {
        name: "TheLogo",
        methods: {
            scrollTo() {
                window.scrollTo({ top: 0, behavior: "smooth" });
            },
        },
    };
</script>

<template>
    <router-link
        :to="{ name: 'Home' }"
        class="the-logo"
        @click.native="scrollTo"
    ></router-link>
</template>

<style lang="scss"></style>
